export default "__VITE_ASSET__cDwMU4kl__"